import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { InfosComponent } from './infos/infos.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: InfosComponent,
      },
      {
        path: 'admin',
        component: AdminComponent,
      },
      {
        path: 'packets',
        loadChildren: () =>
          import('./packets/packets.module').then((m) => m.PacketsModule),
      },
      {
        path: 'tools',
        loadChildren: () =>
          import('./tools/tools.module').then((m) => m.ToolsModule),
      },
      {
        path: 'other',
        loadChildren: () =>
          import('./other/other.module').then((m) => m.OtherModule),
      },
      {
        path: 'vantransfer',
        loadChildren: () =>
          import('./van-transfer/van-transfer.module').then(
            (m) => m.VanTransferModule
          ),
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./report/report.module').then((m) => m.ReportModule),
      },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
